import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import { keyframes } from '@mui/system';
import {
  AirportShuttle,
  Wifi,
  BreakfastDining,
  CleaningServices,
  LocalLaundryService,
  Pool,
  Tv,
  KingBed,
  LocalDrink,
  Coffee,
  SportsEsports,
  LibraryBooks,
  Work,
  Soap,
} from '@mui/icons-material';
import outdoorImage from '../../images/swiper5.jpg'; // Replace with your outdoor image
import garden3 from '../../images/garder.jpg'; // Replace with your pool image
import garden1 from '../../images/6D5A0194 A.jpg'; // Replace with your pool image
import garden2 from '../../images/6D5A0211 A.jpg'; // Replace with your pool image
import garden from '../../images/6D5A0285.jpg'; // Replace with your pool image

// Keyframes for Animation
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

function SecSeven() {
  return (
    <Box sx={{ py: 8, backgroundColor: '#fff' }}>
      <Container maxWidth="lg">
        {/* Top Section */}
        <Grid container spacing={4}>
          {/* Left Image with Animation */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: {
                xs: 'none', // Hide for extra small screens
                sm: 'none', // Hide for small screens
                md: 'block', // Show for medium and larger screens (1024px and above)
              },
              animation: `${fadeInRight} 1s ease-in-out`,
            }}
          >
            <Box
              component="img"
              src={garden1}
              alt="Outdoor Image"
              sx={{
                width: '100%',
                height: '30%',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
              }}
            /> <Box
              component="img"
              src={garden2}
              alt="Outdoor Image"
              sx={{
                width: '100%',
                height: '30%',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
              }}
            /><Box
              component="img"
              src={garden3}
              alt="Outdoor Image"
              sx={{
                width: '100%',
                height: '30%',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
              }}
            />
            {/* Footer Section */}
            <Box
              sx={{
                mt: 4,
                textAlign: 'center',
                fontStyle: 'italic',
                color: '#6c757d',
                fontFamily: "'Playfair Display', serif",
              }}
            >
          <b> Book Your Getaway Today</b> <br />
Escape the ordinary and discover the magic of the Knuckles Mountains with Unseen Knuckles Eco Boutique. Whether you’re planning a nature-focused holiday, a Sri Lankan honeymoon, or a wellness retreat surrounded by nature, we’re here to help you craft memories that last a lifetime.
            </Box>
          </Grid>

          {/* Right Text */}
          <Grid item xs={12} md={6}>
            <Box>
              <Typography
                variant="body2"
                sx={{
                  textTransform: 'uppercase',
                  fontSize: '0.9rem',
                  letterSpacing: '0.15em',
                  mb: 1,
                  color: '#6c757d',
                }}
              >
                Discover the Services We Offer
              </Typography>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: "'Playfair Display', serif",
                  fontWeight: '600',
                  fontSize: '2.3rem',
                  mb: 4,
                  color: '#000',
                  lineHeight: 1.3,
                }}
              >
                All the Essentials for a Cozy and Comfortable Stay
              </Typography>

              {/* Features Grid */}
              <Grid container spacing={2}>
                {/* Row 1 */}
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <Pool sx={{ fontSize: '2rem', color: '#a67c52', mr: 2 }} />
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: '600', fontSize: '1.1rem' }}>
                        Private Plunge Pool
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6c757d' }}>
                        Unwind with a refreshing dip surrounded by serene natural beauty.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <Coffee sx={{ fontSize: '2rem', color: '#a67c52', mr: 2 }} />
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: '600', fontSize: '1.1rem' }}>
                        Tea/Coffee Making Facility
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6c757d' }}>
                        Start your day with a freshly brewed cup in the comfort of your room.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                {/* Row 2 */}
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <LocalDrink sx={{ fontSize: '2rem', color: '#a67c52', mr: 2 }} />
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: '600', fontSize: '1.1rem' }}>
                        Unlimited Fresh Spring Water
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6c757d' }}>
                        Stay hydrated with a continuous supply of pure spring water.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <Wifi sx={{ fontSize: '2rem', color: '#a67c52', mr: 2 }} />
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: '600', fontSize: '1.1rem' }}>
                        Free WiFi
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6c757d' }}>
                        Stay connected with high-speed internet access.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                {/* Row 3 */}
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <Tv sx={{ fontSize: '2rem', color: '#a67c52', mr: 2 }} />
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: '600', fontSize: '1.1rem' }}>
                        Satellite TV
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6c757d' }}>
                        Enjoy premium entertainment options with satellite TV channels.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <Work sx={{ fontSize: '2rem', color: '#a67c52', mr: 2 }} />
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: '600', fontSize: '1.1rem' }}>
                        Dedicated Working Station
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6c757d' }}>
                        A comfortable workspace for leisure and productivity.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                {/* Row 4 */}
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <LibraryBooks sx={{ fontSize: '2rem', color: '#a67c52', mr: 2 }} />
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: '600', fontSize: '1.1rem' }}>
                        Reading Corner
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6c757d' }}>
                        Cozy nook with books for quiet moments or reflection.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <Soap sx={{ fontSize: '2rem', color: '#a67c52', mr: 2 }} />
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: '600', fontSize: '1.1rem' }}>
                        Toiletries & Hair Dryer
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6c757d' }}>
                        Luxurious toiletries and a hair dryer for your convenience.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                {/* Final Row */}
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <SportsEsports sx={{ fontSize: '2rem', color: '#a67c52', mr: 2 }} />
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: '600', fontSize: '1.1rem' }}>
                        Board Games
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6c757d' }}>
                        Perfect for a cozy night in with loved ones.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <KingBed sx={{ fontSize: '2rem', color: '#a67c52', mr: 2 }} />
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: '600', fontSize: '1.1rem' }}>
                        Luxury Bedding
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6c757d' }}>
                        Indulge in restful nights with premium quality bedding.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    {/* Bottom Section */}
                    <Grid container spacing={4} sx={{ mt: 6 }}>
                      <Grid
                        item
                        xs={12}
                        sx={{
                          animation: `${fadeInUp} 1s ease-in-out`,
                        }}
                      >
                        <Box
                          component="img"
                          src={garden}
                          alt="Pool Area"
                          sx={{
                            width: '100%',
                            height: 'auto',
                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          
        </Grid>
      </Container>
    </Box>
  );
}

export default SecSeven;
